export default "__VITE_ASSET__jNvsQFVR__"